
import { Toaster as Toaster_1, toast } from "sonner";
import { Cmd_ofEffect } from "./fable_modules/Fable.Elmish.5.0.2/cmd.fs.js";
import { createElement, useEffect, useState } from "react";
import React from "react";
import { defaultOf } from "./fable_modules/fable-library-js.5.3.0/Util.js";

export function error(msg) {
    toast.error(msg);
}

export function success(msg) {
    toast.success(msg);
}

export function warning(msg) {
    toast.warning(msg);
}

export function info(msg) {
    toast.info(msg);
}

export function dismiss() {
    toast.dismiss();
}

export function Cmd_error(msg) {
    return Cmd_ofEffect((_arg) => {
        error(msg);
    });
}

export function Cmd_success(msg) {
    return Cmd_ofEffect((_arg) => {
        success(msg);
    });
}

export function Cmd_warning(msg) {
    return Cmd_ofEffect((_arg) => {
        warning(msg);
    });
}

export function Cmd_info(msg) {
    return Cmd_ofEffect((_arg) => {
        info(msg);
    });
}

/**
 * Renders the sonner Toaster, but only after the component has mounted.
 * 
 * The server SSR markup (Server.Render) does not include the Toaster, so its
 * <section> element is absent from the hydration HTML. Rendering it on the first
 * (hydration) pass would make the client tree contain a trailing <section> that the
 * server tree lacks, which React's concurrent hydrateRoot rejects with
 * "Expected server HTML to contain a matching <section> in <div>" (React #418/#423).
 * Deferring the Toaster to a post-mount render keeps the hydration markup identical.
 */
export function Toaster() {
    const patternInput = useState(false);
    useEffect(() => {
        patternInput[1](true);
    }, []);
    if (patternInput[0]) {
        return createElement(Toaster_1, {
            richColors: true,
            position: "top-right",
            closeButton: true,
        });
    }
    else {
        return defaultOf();
    }
}

export function toaster() {
    return createElement(Toaster, null);
}

//# sourceMappingURL=Toast.js.map
